module.exports = __webpack_public_path__ + "img/card_title_bg.5d2b0c73.png";